{
  "culture": "en",
  "texts": {
    "AbpUi": {
      "Close": "Close",
      "Hours": "Hours",
      "Minutes": "Minutes",
      "Seconds": "Seconds",
      "First": "First",
      "Previous": "Previous",
      "Next": "Next",
      "Last": "Last",
      "SelectMonth": "Select month",
      "SelectYear": "Select year",
      "PreviousMonth": "Previous month",
      "NextMonth": "Next month",
      "IncrementHours": "Increment hours",
      "DecrementHours": "Decrement hours",
      "IncrementMinutes": "Increment minutes",
      "DecrementMinutes": "Decrement minutes",
      "IncrementSeconds": "Increment seconds",
      "DecrementSeconds": "Decrement seconds"
    },
    "AbpTable": {
      "Sort": "Sort",
      "Ascending": "Ascending",
      "Descending": "Descending",
      "Filter": "Filter",
      "SelectAll": "Select all",
      "ClearFilters": "Clear filters",
      "ApplyFilters": "Apply filters"
    },
    "TourType": {
      "ConfirmDelete": "Are you sure you want to delete the tour type?",
      "DeleteSuccess": "Tour type deleted successfully",
      "DeleteError": "An error occurred while deleting the tour type",
      "UpdateSuccess": "Tour type updated successfully",
      "CreateSuccess": "Tour type created successfully"
    },
    "Tour": {
      "DeleteSuccess": "Tour deleted successfully",
      "DeleteError": "Error deleting tour",
      "FormSaved": "Form saved",
      "UserModifiedSuccess": "User modified",
      "UserModifyError": "Error modifying user",
      "SaveFormError": "Error saving form",
      "CreateSuccess": "Tour created successfully",
      "FillRequiredFields": "Fill in the required fields",
      "ErrorSavingForm": "Error saving form",
      "OfflineFormSaved": "Data will be saved when you regain connection",
      "TourDeleted": "Tour deleted successfully",
      "ErrorDeletingTour": "Error deleting tour",
      "ConfirmModifyResponsible": "Do you want to modify the tour's responsible person?",
      "AnswerTitle": "Answer tour",
      "AnswerSelectAtLeastOneOption": "You must select at least one option",
      "AnswerNoFieldsToShow": "There are no fields to show",
      "AnswerNoUnassignedActionsToShow": "There are no unassigned actions to show",
      "AnswerShowOnlyUnassignedActions": "Show only unassigned actions",
      "AnswerUnassignedActionsCount": "Unassigned actions",
      "AnswerCancelButton": "Cancel",
      "AnswerSaveButton": "Save",
      "AnswerFieldStatus": "Status",
      "AnswerSelectAtLeastOneAction": "You must select at least one action",
      "AnswerFieldActions": "Actions",
      "AnswerMustEnterNumber": "You must enter a number",
      "AnswerActionWithoutResponsible": "Action without responsible user",
      "AnswerFilesAndDocuments": "Files and documents",
      "AnswerNoAttachedFiles": "There are no attached files",
      "AnswerAddComment": "Add comment",
      "AnswerUnassignedWarningTitle": "Unassigned actions",
      "AnswerUnassignedWarningDescription": "There are actions without a responsible user. If you continue, the form will still be saved.",
      "AnswerUnassignedWarningCancel": "Back",
      "AnswerUnassignedWarningConfirmAndSave": "Save anyway",
      "AnswerUnassignedWarningDefaultItem": "Field {0}",
      "AnswerUnassignedWarningDefaultAction": "Action {0}"
    },
    "Form": {
      "IntroduceName": "Enter a name",
      "SelectUnitOfMeasure": "You must select a unit of measure",
      "ErrorLoadingForm": "Error loading form",
      "ErrorUpdatingForm": "Error updating form",
      "ErrorCreatingForm": "Error creating form",
      "IncompleteForm": "Incomplete form",
      "MandatoryActionWithoutAllowAction": "There cannot be mandatory actions without allowed actions",
      "UpdatedSuccess": "Form updated successfully",
      "CreatedSuccess": "Form created successfully",
      "FormCreated": "Form created successfully"
    },
    "Action": {
      "NoUsersFound": "No possible users found",
      "OnlyImagesOrPdfAllowed": "Only images or PDF files are allowed",
      "OperationSuccess": "Operation successful",
      "UpdateSuccess": "Action has been updated successfully",
      "SavedSuccessfully": "Action saved successfully",
      "ActionSavedSuccessfully": "Action saved successfully",
      "ErrorSavingAction": "Error saving action",
      "ReviewSavedSuccess": "Review saved successfully",
      "Complete": "Complete",
      "Review": "Review",
      "Details": "Details",
      "ConfirmModifyResponsible": "Do you want to modify the action's responsible person?",
      "ErrorModifyingUser": "Error modifying user"
    },
    "User": {
      "Created": "User created",
      "AssignedSuccessfully": "User assigned successfully"
    },
    "TourReport": {
      "CombineSyncMessage": "The combination will be synchronized when sending the form response",
      "CombineSuccess": "The selected tours have been combined successfully."
    },
    "Error": {
      "ErrorCreatingTourType": "An error occurred while creating the tour type",
      "ErrorUpdatingTourType": "An error occurred while updating the tour type",
      "NameRequired": "Name is required",
      "PlanRequired": "You must select a plan",
      "DaysBeforeAlertRequired": "Days before alert are required",
      "DaysBeforeAlertMin": "Days before alert must be greater than 0",
      "ProcessRequired": "You must select a process",
      "TimeToRealizeJobRequired": "Time to complete the tour is required",
      "TimeToRealizeJobMin": "Time to complete the job must be greater than 0",
      "CreateUserError": "Error creating user",
      "InvalidUsernameOrPassword": "Invalid username or password",
      "PasswordMustBeSame": "Passwords do not match"
    },
    "Validation": {
      "SelectAtLeastTwoTourReportsToCombine": "You must select at least two tour reports to combine.",
      "TourReportsMustBeOfSameType": "Tour reports must be of the same type.",
      "SelectAtLeastOneActionForField": "You must select an action in the attribute {0}",
      "SelectAtLeastOneOption": "You must select at least one option in the form",
      "ReviewAlreadyExistsForAction": "A review already exists for this action",
      "FormResponseAlreadyExistsForAction": "A review already exists for this action"
    },
    "File": {
      "DeleteFileConfirmation": "Are you sure you want to delete the file {0}?",
      "TotalFilesSizeExceeded": "The total size of the files exceeds the maximum allowed size of {0} MB",
      "DuplicateFileName": "The file {0} is already loaded, it cannot be loaded twice"
    }
  }
} 